import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useSWR from 'swr'
import { useAuth } from '../../context/auth'
import { getPlanLimits } from '../../api'
import { clearNewInvoiceDraftStorage } from '../../lib/invoiceDraftStorage'
import Button from '../ui/button'
import Spinner from '../ui/spinner'

/**
 * Renders 'New Invoice' button. If user is at free plan limit and not subscribed,
 * links to /get-premium. Otherwise links to /invoices/new.
 */
const NewInvoiceLink = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { data: planLimits, isLoading } = useSWR('/api/plan-limits', getPlanLimits)
  const maxInvoices = planLimits?.maxAmountOfInvoices ?? 0
  const atLimit = typeof user?.invoiceCount === 'number' && user.invoiceCount >= maxInvoices
  const hasActiveSubscription = !!user?.hasActiveSubscription
  const freeAccess = !!planLimits?.freeAccess
  const shouldUpgrade = atLimit && !hasActiveSubscription && !freeAccess

  const handleClick = () => {
    if (shouldUpgrade) {
      navigate('/get-premium')
      return
    }
    clearNewInvoiceDraftStorage()
    if (location.pathname === '/invoices/new') {
      navigate('/invoices/new', { replace: true, state: { discardDraft: Date.now() } })
      return
    }
    navigate('/invoices/new')
  }

  if(isLoading) { return <Spinner /> }
  return (
    <Button onClick={handleClick}>New Invoice</Button>
  )
}

export default NewInvoiceLink
